function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 62,
  height: 50,
  x: 1,
  y: 7,
  fill: "#c2cde7",
  rx: 2,
  ry: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffeb9b",
  d: "M45 23a3 3 0 100 6 3 3 0 100-6zm10 10a3 3 0 100 6 3 3 0 100-6zm-20-2a3 3 0 100 6 3 3 0 100-6z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#bbdef9",
  d: "M27 25a2 2 0 01-2 2H9a2 2 0 01-.82-.17A2 2 0 017 25.07V25a10 10 0 0110.54-10h.5c.24 0 .48.06.71.11a9.52 9.52 0 013.42 1.3 9.88 9.88 0 013.78 4.09 9.07 9.07 0 01.89 2.66A10.35 10.35 0 0127 25z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#acb7d0",
  d: "M5 50h54a4 4 0 014 4v1a2 2 0 01-2 2H3a2 2 0 01-2-2v-1a4 4 0 014-4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d2edff",
  d: "M25.95 20.55L20.86 27h-7l8.31-10.54a9.88 9.88 0 013.78 4.09zm-5.2-5.39L11.37 27H11a2 2 0 01-.82-.17L19.54 15h.5c.24.08.48.11.71.16z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M61 6H3a3 3 0 00-3 3v46a3 3 0 003 3h58a3 3 0 003-3V9a3 3 0 00-3-3zm1 49a1 1 0 01-1 1H3a1 1 0 01-1-1V9a1 1 0 011-1h58a1 1 0 011 1z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M55 30a1 1 0 001-1V15a1 1 0 00-2 0v14a1 1 0 001 1zM45 20a1 1 0 001-1v-4a1 1 0 00-2 0v4a1 1 0 001 1zm-10 8a1 1 0 001-1V15a1 1 0 00-2 0v12a1 1 0 001 1zM12 48a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm-5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm40 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm-30 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm10 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zM45 22a4 4 0 00-1 7.87V43a1 1 0 002 0V29.87A4 4 0 0045 22zm1 5.73A2 2 0 1147 26a2 2 0 01-1 1.73zM55 32a4 4 0 00-1 7.87V43a1 1 0 002 0v-3.13A4 4 0 0055 32zm1 5.73A2 2 0 1157 36a2 2 0 01-1 1.73zM35 30a4 4 0 00-1 7.87V43a1 1 0 002 0v-5.13A4 4 0 0035 30zm1 5.73A2 2 0 1137 34a2 2 0 01-1 1.73zM18.14 14.06a10.91 10.91 0 00-8.52 2.78A11.06 11.06 0 006 25.08 3 3 0 009 28h16a3 3 0 003-3 11.33 11.33 0 00-.17-2 11 11 0 00-9.69-8.94zM26 25a1 1 0 01-1 1h-6.83l2.69-4.49a1 1 0 10-1.71-1l-3 5A1 1 0 0016 26H9a1 1 0 01-1-1 9 9 0 013-6.68A8.9 8.9 0 0117 16a9.47 9.47 0 011 0 9.09 9.09 0 017.92 7.34A9.27 9.27 0 0126 25zM9 34h8a1 1 0 000-2H9a1 1 0 000 2zm14 6H9a1 1 0 000 2h14a1 1 0 000-2zm2-8h-4a1 1 0 000 2h4a1 1 0 000-2zM9 38h12a1 1 0 000-2H9a1 1 0 000 2z"
});

function SvgControlPannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 256,
    height: 256
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgControlPannel;